import {
  createFileRoute,
  redirect,
  stripSearchParams,
} from '@tanstack/react-router'
import { z } from 'zod'
import { hasAbility } from '@/lib/rbac'
import { PhonesPage } from '@/components/phones/phones-page'
import { phoneVerificationStatuses } from '@/components/phones/phone-verification-status'

export const phoneProviderFilterValues = [
  'all',
  'masip',
  'twilio',
  'baway',
  'didww',
  'client_external',
] as const

export const phoneVerificationStatusFilterValues = [
  'all',
  ...phoneVerificationStatuses,
] as const

const defaultValues = {
  page: 0,
  provider: 'all' as const,
  verificationStatus: 'all' as const,
}

export const phonesSearchSchema = z.object({
  page: z
    .number()
    .int()
    .min(0)
    .default(defaultValues.page)
    .catch(defaultValues.page),
  cursor: z.string().nullable().optional(),
  q: z.string().optional(),
  history: z.string().optional(),
  provider: z
    .enum(phoneProviderFilterValues)
    .default(defaultValues.provider)
    .catch(defaultValues.provider),
  verificationStatus: z
    .enum(phoneVerificationStatusFilterValues)
    .default(defaultValues.verificationStatus)
    .catch(defaultValues.verificationStatus),
  countryCode: z.string().optional(),
  accountId: z.string().optional(),
  accountName: z.string().optional(),
})

export const Route = createFileRoute('/_auth/_main-layout/phones')({
  beforeLoad: () => {
    if (!hasAbility('manage_phones')) {
      throw redirect({ to: '/accounts' })
    }
  },
  component: PhonesPage,
  validateSearch: phonesSearchSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
})
